// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"378b30bbe57d6aa5cbdc","453":"0a51d4d9f8bcb1ec3888","672":"84b3d694a23d8a2c8dcc"}[chunkId] + ".js";
};